<app-grid-modal
  [header]="header"
  [columnDefs]="columnDefs"
  [summaryTop]="model"
  [rowData$]="rowData$"
  [showDelete]="showDelete"
  [showBack]="showBack"
  [summaryItems]="summaryItems"
  (delete)="delete($event)"
></app-grid-modal>
